var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-details"},[_c('span',[_vm._v("Logged in as "),_c('b',[_vm._v(_vm._s(_vm.user.email))])]),_vm._v(" "),_c('b-button',{attrs:{"size":"xs"},on:{"click":function($event){_vm.logOut()}}},[_vm._v("Log out")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039573d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserDetails.vue
// module id = 263
// module chunks = 1